import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Card from '../Card';
import swal from 'sweetalert2';
import * as ProAct from '../../Actions/ProActions';
import { enregistreAdresseFE, obtenirProprietaire } from '../../App_Code/API';
import ModalAdresseFE from './ModalAdresseFE';

const CardAdresseFE = (props) => {
    const { AdressesFE, actions, lectureSeule } = props;
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [selectedAdresse, setSelectedAdresse] = React.useState(null);

    const handleRefresh = () => {
        obtenirProprietaire().then((pro) => {
            if (pro) actions.proAjout(pro);
        });
    };

    const handleToggleStatus = async (adr, type) => {
        if (lectureSeule) return;
        const isDesactivation = (type === 'DESACTIVE');
        const text = isDesactivation ? "désactiver" : "réactiver";

        const result = await swal.fire({
            title: 'Confirmation',
            text: `Voulez-vous ${text} cette adresse ?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirmer'
        });

        if (result.value) {
            const payload = { ...adr, ActifOk: isDesactivation ? 0 : 1 };
            try {
                const res = await enregistreAdresseFE(payload);
                if (res && res.status === 200) {
                    swal.fire('Succès', 'Action effectuée', 'success');
                    handleRefresh();
                }
            } catch (e) {
                swal.fire("Erreur", "Erreur technique", "error");
            }
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr || dateStr.includes("1900")) return "";
        if (typeof dateStr === 'string' && dateStr.includes('/')) return dateStr;
        const d = new Date(dateStr);
        return isNaN(d.getTime()) ? "" : d.toLocaleDateString('fr-FR');
    };

    return (
        <div className="mt-4 px-3 pb-3">
            <Card Titre="Adresses de facturation électronique">
                {!lectureSeule && (
                    <div className="p-2 text-end border-bottom bg-light">
                        <button className="btn btn-sm btn-primary shadow-sm" onClick={() => { setSelectedAdresse(null); setIsModalOpen(true); }}>
                            <i className="fa fa-plus me-1"></i> Ajouter une adresse
                        </button>
                    </div>
                )}

                <div className="table-responsive" style={{ maxHeight: '350px' }}>
                    <table className="table table-hover align-middle mb-0" style={{ fontSize: '0.9rem' }}>
                        <thead className="table-light sticky-top">
                            <tr>
                                <th className="text-center" style={{ width: '60px' }}>Etat</th>
                                <th>Adresse FE</th>
                                <th className="text-center">Date début</th>
                                <th className="text-center">Date fin</th>
                                {!lectureSeule && <th className="text-end" style={{ width: '120px' }}>Actions</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {(!AdressesFE || AdressesFE.length === 0) ? (
                                <tr><td colSpan="5" className="text-center p-4 text-muted">Aucune adresse</td></tr>
                            ) : (
                                AdressesFE.map((item) => (
                                    <tr key={item.NumAuto} className={item.ActifOk ? '' : 'table-light text-muted'}>
                                        <td className="text-center">
                                            <i className={"fa fa-" + (item.ActifOk ? 'check-circle text-success' : 'times-circle text-danger') + " fs-5"}></i>
                                        </td>
                                        <td><span className="fw-bold">{item.AdresseFE}</span></td>
                                        <td className="text-center">{formatDate(item.SQLDateDebMandat)}</td>
                                        <td className="text-center">{formatDate(item.SQLDateFinMandat)}</td>
                                        {!lectureSeule && (
                                            <td className="text-end">
                                                <div className="d-flex justify-content-end gap-2">
                                                    {item.ActifOk ? (
                                                        <React.Fragment>
                                                            <button className="btn btn-link p-0 text-danger" onClick={() => { setSelectedAdresse(item); setIsModalOpen(true); }}>
                                                                <span className="fa-stack fa-xs"><i className="fa fa-circle-thin fa-stack-2x"></i><i className="fa fa-pencil fa-stack-1x"></i></span>
                                                            </button>
                                                            <button className="btn btn-link p-0 text-danger" onClick={() => handleToggleStatus(item, 'DESACTIVE')}>
                                                                <span className="fa-stack fa-xs"><i className="fa fa-circle-thin fa-stack-2x"></i><i className="fa fa-trash fa-stack-1x"></i></span>
                                                            </button>
                                                        </React.Fragment>
                                                    ) : (
                                                        <button className="btn btn-link p-0 text-danger" onClick={() => handleToggleStatus(item, 'REACTIVE')}>
                                                            <span className="fa-stack fa-xs"><i className="fa fa-circle fa-stack-2x text-danger"></i><i className="fa fa-rotate-left fa-stack-1x text-white"></i></span>
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        )}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </Card>

            <ModalAdresseFE 
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                data={selectedAdresse}
                onRefresh={handleRefresh}
            />
        </div>
    );
};

function mapStateToProps(state) {
    return {
        AdressesFE: (state.ProStore && state.ProStore.Pro) ? state.ProStore.Pro.AdressesFE || [] : []
    };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(ProAct, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(CardAdresseFE);


// WEBPACK FOOTER //
// ./src/components/MesInfos/CardAdresseFE.js